export default __webpack_public_path__ + "static/media/voz.73c9fdf0.jpg";